
export const initialStateFx = {
    wagml: '',
    renderExerciseToImageRequested: false
}